/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Läser in...',
	'dlg_close': 'Stäng',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Avbryt',
	'dlg_back': 'Gå tillbaka',

	// Slider
	'sliderRegionLabel': 'Skjutreglage - använd höger- och vänsterpilarna för att flytta skjutreglagehandtagen',
	'sliderHandleLabel': 'Skjutreglagehandtag',
	'a11ySliderHandleLabel': 'Skjutreglagehandtag %{sliderValue}',
	'sliderInputLabel': 'värde',

	// Side bar
	'sidebarAdd': 'Lägg till',
	'clearTextFilterValue': 'Rensa',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',

	// Toolbar
	'toolbarRegionLabel': 'Verktygsfält',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Teckensnitt',
	'fontSizeSelect': 'Teckenstorlek',
	'bold': 'Halvfet',
	'italic': 'Kursiv',
	'underline': 'Understrykning',
	'justifyLeft': 'Vänsterjustera',
	'justifyCenter': 'Centrera',
	'justifyRight': 'Högerjustera',
	'insertOrderedList': 'Numrerad lista',
	'insertUnorderedList': 'Onumrerad lista',
	'fontColorPicker': 'Färgväljare',
	'textWrap': 'Radbryt text',
	'restore': 'Återställ till standardvärden',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Antal resultat',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Värdet kan vara %{lower} - %{higher}',
	'topbottomSelectOption': 'Alternativ för högsta eller lägsta',
	'topbottomOptionLabel': 'Visa',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Inga träffar hittades',
	'topbottomRankColumnLabel': 'Lägg till rangordningskolumn i tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Antal högsta',
	'topPercent': 'Högsta %',
	'bottomCount': 'Antal lägsta',
	'bottomPercent': 'Lägsta %',
	'searchColumn': 'Sök en kolumn',
	'searchColumnAriaLabel': 'Sök en kolumn. Skriv namnet på kolumnen du vill söka efter och klicka på nedåtpilen för att söka efter kolumnen i listan.',
	'rankColumnLabel': 'Rangordna (%{columnLabel})',
	'topbottomClearLabel': 'Rensa',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Konvertera decimal till procent',
	'formatAbbreviate': 'Avrunda',
	'formatUseGrouping': 'Använd tusentalsavgränsare',
	'dateStyle': 'Datumformat',
	'dateTimeStyle': 'Datum-/tidsformat',
	'formatMissingValueCharactersInfo': 'Tecken vid saknat värde anger vilka tecken som ska visas när värdet saknas.',
	'currencySymbolLabel': 'Valutasymbol',
	'customSymbolPlaceholder': 'Lägg till en symbol',
	'customSymbolLabelInfo': 'Anger ett eller flera tecken att användas som anpassad symbol. Den här symbolen anges före talet och eventuella tecken.',
	'numberLabel': 'Nummeretikett',
	'numberPositionLabel': 'Etikettposition',
	'numberLabelInfo': 'Anger en etikett för det formaterade numret och placeras som prefix eller suffix beroende på etikettpositionen.',
	'nullValueDefault': '<standard>',
	'nullValueContent': '(inget värde)',
	'default': 'Standard',
	'beginning': 'Början',
	'end': 'Slut',

	// More data indicator
	'moreDataIndicator': 'Data klipptes av vid %{threshold} objekt. Tillämpa ett filter för att visa färre.',

	// Expanded View / Focus mode
	'evCollapse': 'Komprimera',
	'duplicate': 'Kopiera',
	'copyOf': 'Kopia av %{name}',
	'unableToDuplicateBoard': 'Det går inte att kopiera %{name}.',

	// Widget list
	'errorLoadingWidgetList': 'Det går inte att läsa in objekten.',

	// Custom widgets
	'customWidget': 'Anpassad widget'
});
